import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as lib from '~/dependencies';
import * as NuacomComponent from '~/components';
import * as actions from '~/store/actions';
import { MessagingPlusSign } from '~/assets/svgIcons';
import { RootState } from '~/store/config';
import { ChannelTypeEnum } from '~/enums/conversations';
import { eventTracker } from '~/helpers';
import ConversationList from './components/List';
import BulkActions from './components/BulkActions';
import ChannelMenu from './components/ChannelMenu';
import { Container, Block, Right } from './styles';

export default function Conversations(props: any) {
  // HOOKS
  const dispatch = useDispatch();

  // SELECTORS
  const { conversations } = useSelector(
    (state: RootState) => state.conversation
  );
  const openSelection = useSelector(
    (state: RootState) => state.conversation.openSelection
  );
  const converstionFilters = useSelector(
    (state: RootState) => state.conversation.filters
  );

  // CONST's
  const { type, channelType, search } = converstionFilters;

  useEffect(() => {
    dispatch(actions.getAllConversations());
  }, [dispatch, type, channelType, search]);

  // Call on first render to set the unread messages count
  useEffect(() => {
    dispatch(actions.setUnreadMessagesCount());
    dispatch(actions.fetchSmsSenders());

    return () => {
      dispatch(actions.openConversationSelection(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChannelType = (typeValue: ChannelTypeEnum) => {
    dispatch(actions.setConversationFilter({ channelType: typeValue }));
  };

  return (
    <Container>
      <NuacomComponent.Header {...props} center>
        <ChannelMenu disabled onChange={handleChannelType} />
        <Right>
          <lib.Link
            // @ts-ignore FIXME: Require addtional refactor here to make it work with typescript
            onClick={() => eventTracker(events => events.NewSMSClicked)}
            to="/app/conversations/new"
            aria-label="New Conversation">
            <lib.ReactSVG
              src={MessagingPlusSign}
              style={{ width: 30, height: 30 }}
            />
          </lib.Link>
        </Right>
      </NuacomComponent.Header>

      <Block>
        <ConversationList data={conversations} />
        {openSelection && <BulkActions />}
      </Block>
    </Container>
  );
}
